<template>
	<div>
		<div class="col-lg-9">
			<ts-loading-banner :loading="loading">
				<div v-if="isHasPhoto">
					<div class="ts-p-4">
						<div class="row row-space-4" v-viewer>
							<div class="col-lg-2 col-sm-2 col-3" v-for="(item, index) in value.serial_photo">
								<a class="widget-card square m-b-2 photo-wrapper">
									<img class="widget-card-cover" v-lazy="{
										src: photo(item),
										loading: require('@/assets/Rolling-1s-200px_2.svg')
									}" />
								</a>
							</div>
						</div>
					</div>
				</div>
				<div v-else style="margin: auto; margin-top: 8px; width: 1400px;">
					<h1 class="text-center ts-text-3xl ts-font-bold ts-opacity-25">
						No Photo
					</h1>
				</div>
			</ts-loading-banner>
		</div>
	</div>
</template>
<script>
import { isEmpty } from 'lodash'
import VueViewer from 'v-viewer'
import Vue from 'vue'
import 'viewerjs/dist/viewer.css'
Vue.use(VueViewer)

export default {
	name: 'viewSerialPhoto',
	props: ['value'],
	data() {
		return {
			loading: false
		}
	},
	computed: {
		isHasPhoto() {
			return !isEmpty(this.value.serial_photo)
		}
	},
	methods: {
		photo(record) {
			if (record.storage_path) {
				return record.storage_path
			}
			return require('@/assets/default_user.jpg')
		}
	}
}
</script>
<style scoped lang="scss">
.photo-wrapper {
	background: #fff;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}

.photo-wrapper:hover img {
	padding: 5px;
	opacity: 0.8;
	-webkit-transition: 0.3s ease-in-out;
	transition: 0.3s ease-in-out;
}
</style>
  